/* eslint-disable import/no-cycle */
import { adminApi } from '@/includes/contentManagementApi';

function unwrapView(response) {
  return response?.data?.data ?? response?.data ?? {};
}

const coachingAdminService = {
  async getConfig() {
    const data = unwrapView(await adminApi.get('/coaching/admin/config'));
    return {
      config: data.config ?? data,
      dimensionOptions: data.dimensionOptions ?? [],
      schemaOptions: data.schemaOptions ?? [],
    };
  },

  async updateConfig(payload) {
    const data = unwrapView(await adminApi.patch('/coaching/admin/config', payload));
    return {
      config: data.config ?? data,
      dimensionOptions: data.dimensionOptions ?? [],
      schemaOptions: data.schemaOptions ?? [],
    };
  },

  async bootstrapAssessmentBaselines() {
    const response = await adminApi.post('/coaching/admin/bootstrap-assessment-baselines');
    return response?.data?.data ?? response?.data ?? {};
  },

  async listScoreReviews(status = 'pending_review') {
    const response = await adminApi.get('/coaching/admin/score-reviews', { params: { status } });
    return response?.data?.data ?? response?.data ?? {};
  },

  async getScoreReview(userId, dimensionValue) {
    const response = await adminApi.get(
      `/coaching/admin/score-reviews/${encodeURIComponent(userId)}/${encodeURIComponent(dimensionValue)}`,
    );
    return response?.data?.data ?? response?.data ?? {};
  },

  async resolveScoreReview(userId, dimensionValue, payload) {
    const response = await adminApi.post(
      `/coaching/admin/score-reviews/${encodeURIComponent(userId)}/${encodeURIComponent(dimensionValue)}/resolve`,
      payload,
    );
    return response?.data?.data ?? response?.data ?? {};
  },
};

export default coachingAdminService;
